import { Link } from "react-router-dom"

export default function RepDashboardList() {
  const act = useAct()
  const { dashboards } = useSelector(s => s.local)

  useEffect(() => {
    act.dashboards.load()
  }, [])

  function handleArchive(dashboard) {
    if (window.confirm(`Archive "${dashboard.name}"? It will no longer appear in this list.`)) {
      act.dashboards.archive(dashboard.id)
    }
  }

  return (
    <div>
      <h2>Rep Dashboards</h2>

      <Link to={`/rep_dashboards/new`} className="button primary">Create a new dashboard</Link>

      { (dashboards || []).map(dashboard => <div key={dashboard.id}>
        <h3>{dashboard.name}</h3>
        { dashboard.actions.length > 0 && <p>Actions: {dashboard.actions.map(a => `${a.name} (${a.checklistName})`).join(', ')}</p> }
        { dashboard.actions.length === 0 && <p>This dashboard isn't on any live actions.</p> }
        <Link to={`/rep_dashboards/${dashboard.id}`} className="button smallest green">Edit</Link>
        {' '}
        <button className="button smallest" style={{ background: '#e0e0e0', color: '#333' }} onClick={() => handleArchive(dashboard)}>Archive</button>
      </div>) }
    </div>
  );
};
